import React from 'react';
import { Nav } from 'react-bootstrap';
import { Link, useLocation, useRouteMatch } from 'react-router-dom';
import { ServicesContext } from '~/services';

// Type assertion for TypeScript 5.x compatibility with react-router-dom v5
const LinkComponent = Link as any;

export function AdminTabs() {
    const location = useLocation();
    const match = useRouteMatch();
    const servicesContext = React.useContext(ServicesContext);

    return (
        <Nav variant="tabs" activeKey={location.pathname} className="mb-sm-2">
            {(servicesContext.user.isGlobalAdmin() ||
                servicesContext.user.isOrganizationAdmin()) && (
                <Nav.Item>
                    <Nav.Link as={LinkComponent} href={`${match.url}/users`} to="/admin/users">
                        Users
                    </Nav.Link>
                </Nav.Item>
            )}
            {(servicesContext.user.isGlobalAdmin() ||
                servicesContext.user.isOrganizationAdmin() ||
                servicesContext.user.isReportYearAdmin()) && (
                <Nav.Item>
                    <Nav.Link
                        as={LinkComponent}
                        href={`${match.url}/reportyear`}
                        to="/admin/reportyear"
                    >
                        Report Year
                    </Nav.Link>
                </Nav.Item>
            )}
            {servicesContext.user.isMACLAdmin() && (
                <Nav.Item>
                    <Nav.Link as={LinkComponent} href={`${match.url}/macl`} to="/admin/macl">
                        MACL
                    </Nav.Link>
                </Nav.Item>
            )}
            {servicesContext.user.isBannerAdmin() && (
                <Nav.Item>
                    <Nav.Link as={LinkComponent} href={`${match.url}/banner`} to="/admin/banner">
                        Banners
                    </Nav.Link>
                </Nav.Item>
            )}
            {servicesContext.user.isGlobalAdmin() && (
                <Nav.Item>
                    <Nav.Link as={LinkComponent} href={`${match.url}/reports`} to="/admin/reports">
                        Reports
                    </Nav.Link>
                </Nav.Item>
            )}
        </Nav>
    );
}
